__turbopack_context__.v({
  "timeText": "DE51BG_timeText",
  "timeTextContainer": "DE51BG_timeTextContainer",
});
